import Card from "@mui/material/Card";
import SoftBox from "../../../components/SoftBox";
import {useNavigate, useParams} from "react-router-dom";
import {getBranchAdminById} from "../../../api/branchadmin/branchAdminApiClient";
import React, {useEffect, useState} from "react";
import {Alert, Button, CardContent, Chip, CircularProgress, Grid, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import BranchAdminInfo from "./BranchAdminInfo";
import {useRayzayUIController} from "../../../context";

function BranchAdminDetailPage() {
    const theme = useTheme();
    const navigate = useNavigate();
    const {branchAdminId} = useParams();
    const [branchAdmin, setBranchAdmin] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [controller] = useRayzayUIController();
    const {loggedInUserDetail} = controller;

    const loadBranchAdminDetails = async () => {
        setLoading(true);
        setError(null);
        console.log('Loading branch admin details for ID:', branchAdminId);

        try {
            const res = await getBranchAdminById(branchAdminId);
            console.log('Branch Admin API response:', res);
            const branchAdminData = res.data;
            setBranchAdmin(branchAdminData);
        } catch (error) {
            console.error("Failed to load branch admin details:", error);
            if (error.response?.status === 403) {
                setError("Access denied. You don't have permission to view branch admin details.");
            } else if (error.response?.status === 401) {
                setError("Authentication required. Please log in again.");
            } else if (error.response?.status === 404) {
                setError("Branch admin not found.");
            } else {
                setError("Failed to load branch admin details. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (branchAdminId) {
            loadBranchAdminDetails();
        }
    }, [branchAdminId]);

    if (loading) {
        return (
            <SoftBox display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                <CircularProgress/>
            </SoftBox>
        );
    }

    if (error) {
        return (
            <SoftBox p={3}>
                <Alert severity="error">{error}</Alert>
                {error.includes("Access denied") && (
                    <SoftBox mt={2}>
                        <Typography variant="body2" color="text.secondary" mb={2}>
                            Current user role: {loggedInUserDetail?.userRole || 'Not logged in'}
                        </Typography>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => navigate('/authentication/sign-in')}
                        >
                            Sign In
                        </Button>
                    </SoftBox>
                )}
            </SoftBox>
        );
    }

    return (
        <SoftBox>
            <SoftBox mb={3}>
                <Typography variant="h4" gutterBottom>
                    Branch Admin Details
                </Typography>
            </SoftBox>

            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <Card>
                        <CardContent>
                            <SoftBox display="flex" flexDirection="column" alignItems="center" p={2}>
                                <SoftBox
                                    component="img"
                                    src={branchAdmin.profilePic ? `data:image/png;base64,${branchAdmin.profilePic}` : undefined}
                                    alt="Branch Admin Profile"
                                    sx={{
                                        width: 150,
                                        height: 150,
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        border: `3px solid ${theme.palette.grey[300]}`,
                                        mb: 2
                                    }}
                                />
                                <Typography variant="h5" gutterBottom>
                                    {branchAdmin.firstName} {branchAdmin.lastName}
                                </Typography>
                                <Chip
                                    label={branchAdmin.userRole || 'BRANCH_ADMIN'}
                                    color="primary"
                                    variant="outlined"
                                    sx={{mb: 1}}
                                />
                                <Chip
                                    label={branchAdmin.status || 'ACTIVE'}
                                    color={branchAdmin.status === 'ACTIVE' ? 'success' : 'error'}
                                    variant="outlined"
                                />
                            </SoftBox>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={8}>
                    <BranchAdminInfo branchAdmin={branchAdmin}/>
                </Grid>
            </Grid>
        </SoftBox>
    );
}

export default BranchAdminDetailPage;
